export default __webpack_public_path__ + "static/media/accept.af2a744f.png";